export default __webpack_public_path__ + "static/genre_03-1f3a6a6bfb574e5fd68be9891a13994c.png";